import { Chromosome } from "../Chromosome.js";

export const chromosomeNameMap: Record<Chromosome, string> = {
	[Chromosome.C1]: "1",
	[Chromosome.C2]: "2",
	[Chromosome.C3]: "3",
	[Chromosome.C4]: "4",
	[Chromosome.C5]: "5",
	[Chromosome.C6]: "6",
	[Chromosome.C7]: "7",
	[Chromosome.C8]: "8",
	[Chromosome.C9]: "9",
	[Chromosome.C10]: "10",
	[Chromosome.C11]: "11",
	[Chromosome.C12]: "12",
	[Chromosome.C13]: "13",
	[Chromosome.C14]: "14",
	[Chromosome.C15]: "15",
	[Chromosome.C16]: "16",
	[Chromosome.C17]: "17",
	[Chromosome.C18]: "18",
	[Chromosome.C19]: "19",
	[Chromosome.C20]: "20",
	[Chromosome.C21]: "21",
	[Chromosome.C22]: "22",
	[Chromosome.X]: "X",
	[Chromosome.Y]: "Y",
};
